import React from "react";
import axios from "axios";
import Costanti from "../../constantiX";
import { Toast, TabView, TabPanel, Button, ConfirmDialog } from "primereact";
import ListaMaterie from "../DettagliProdotto/listaMaterie";
import ListaAllergeni from "../DettagliProdotto/listaAllergeni";
import ListaProduzioni from "../Produzioni/listaProduzioni";
import ListaLotti from "../DettagliProdotto/listaLotti";
import ListaAnnata from "../DettagliProdotto/listaAnnata";
import ListaCaratteristiche from "../DettagliProdotto/listaCaratteristiche";
import * as Yup from "yup";
import ReactGA from "react-ga4";
import { Link } from "react-router-dom";
import ListaCertificazioniProdotto from "../Certificazioni/listaCertificazioniProdotto";

import Moment from "moment";
import Details from "../DettagliProdotto/Details";

class Prodotto extends React.Component {
  constructor() {
    super();
    this.state = { xcarica: "sezione", dati: [], prodotto: {}, prodottoid: 0, visible3: false, editMode: false };
    this.token = sessionStorage.getItem("ICEtoken");
    this.utente = JSON.parse(sessionStorage.getItem("utente"));
  }

  showMessage(tipo, messageError, dettaglio) {
    var icona = "";
    if (tipo == "error") {
      icona = "pi pi-times-circle";
    }
    if (tipo == "info") {
      icona = "pipi-info-circle";
    }
    if (tipo == "success") {
      icona = "pi pi-check-circle";
    }
    if (tipo == "warning") {
      icona = "pi pi-exclamation-triangle";
    }
    this.toastBC.show({
      severity: tipo,
      life: 3000,
      closable: false,
      content: (
        <div className="flex flex-column" style={{ flex: "1" }}>
          <div className="text-center">
            <i className={icona} style={{ fontSize: "3rem" }}></i>
            <h4>{messageError}</h4>
            <h5>{dettaglio}</h5>
          </div>
        </div>
      ),
    });
  }
  setVisible3(val) {
    this.setState({ visible3: val });
  }

  setEditMode(val) {
    this.setState({ editMode: val });
  }

  componentDidMount() {
    //alert(this.props.location.pathname);
    //ReactGA.send({ hitType: "pageview", page: this.props.location.pathname });
    this.id = this.props.match.params.id;
    this.tipo = this.props.match.params.tipo;

    this.setState({ tipo: this.props.match.params.tipo, prodottoid: this.props.match.params.id });

    this.carica();
  }

  async carica() {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    if (this.tipo == "A") {
      this.setState({ editMode: true });
    } else {
      this.setState({ loading: true });
      var quer = this.id;
      const res = await axios.get(Costanti.UrlCallApi + "prodotto/" + quer, config);
      this.setState({ dati: res.data, loading: false, editMode: false });
    }
  }

  reset() {
    this.setEditMode(false);

    this.carica();
  }
  notarizza2() {
    this.showMessage("info", "Notarizzo", this.state.dati.codiceprodotto + " " + this.state.dati.nome);

    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ isSubmitting: true });

    axios
      .get(Costanti.UrlCallApi + "notarizzazione/prodotto/" + this.state.prodottoid, config)
      .then((res) => {
        this.showMessage("success", "Dati salvati correttamente", "");
        this.setState({ isSubmitting: false, dati: res.data, prodottoid: res.data.id });
        window.location.reload();
      })
      .catch((error) => {
        this.showMessage("error", "Errore nel salvataggio", error.message);
        this.setState({ isSubmitting: false, editMode: false });
      });
  }

  setPDF(value) {
    let dati = {
      url: Costanti.BaseHttp,
    };

    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    axios
      .post(Costanti.UrlCallApi + "stampe/dettprodotto/" + this.state.prodottoid, dati, config)
      .then((res) => {
        const link = document.createElement("a");
        const url = Costanti.UrlCallApi + "file/getFile/" + res.data;

        link.href = url;
        link.setAttribute("download", res.data);
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        this.showMessage("error", "Errore nella stampa", error.message);
        this.setState({ isSubmitting: false });
      });
  }

  validationSchema() {
    return Yup.object().shape({
      codiceprodotto: Yup.string().required("codiceprodotto obbligatorio").typeError("codiceprodotto obbligatorio"),
      nome: Yup.string().required("Nome obbligatorio").typeError("Nome obbligatorio"),
    });
  }

  getName() {
    const nome =
      this.state.dati &&
      this.state.dati.traduzione &&
      this.state.dati.traduzione.length > 0 &&
      this.state.dati.traduzione.find((el) => el.lingua === "it");
    return nome.testo || "";
  }

  render() {
    return (
      <div className="surface-section px-1 py-9 md:px-6 lg:px-8">
        <Toast ref={(el) => (this.toastBC = el)} position="bottom-center" />

        {this.state.prodottoid >= 0 ? (
          <div
            className="flex w-full flex-row justify-content-between align-items-center 
          "
          >
            <Link to="/listaProdotti">Torna alla lista</Link>
            {this.state.prodottoid > 0 && (
              <div>
                {this.state.dati.codiceprodotto && (
                  <Button
                    label={this.getName() + "    [" + this.state.dati.codiceprodotto + "]"}
                    className="mx-2 p-button-outlined font-bold p-button p-button-danger"
                    disabled
                  />
                )}
                {(this.utente.ruoloid == 3 || Costanti.Ambiente == "TEST") && !this.state.dati.lastnotarize ? (
                  <Button
                    label="Notarizza"
                    onClick={() => this.setVisible3(true)}
                    icon="pi pi-building"
                    className="p-button-rounded p-button-warning"
                  />
                ) : null}

                {(this.utente.ruoloid == 3 || Costanti.Ambiente == "TEST") && this.state.dati.lastnotarize ? (
                  <Button
                    label={
                      "Ultima Notarizzazione " +
                      Moment(new Date(this.state.dati.lastnotarize)).format("DD/MM/yyyy HH:mm:ss")
                    }
                    className="ml-3 p-button-outlined font-bold p-button p-button-danger mx-2"
                    disabled="true"
                  />
                ) : (
                  ""
                )}

                <Button
                  label="Esporta in Pdf"
                  onClick={() => this.setPDF(true)}
                  icon="pi pi-file-pdf"
                  className="mx-2 p-button-rounded p-button-danger "
                />
              </div>
            )}
          </div>
        ) : null}

        <TabView>
          <TabPanel header="Dettaglio">
            <Details product={this.state.dati} />
          </TabPanel>
          <TabPanel header="Caratteristiche">
            <ListaCaratteristiche prodottoid={this.state.prodottoid} stato={this.state.tipo} />
          </TabPanel>
          <TabPanel header="Materie Prime">
            <ListaMaterie prodottoid={this.state.prodottoid} stato={this.state.tipo} />
          </TabPanel>
          {sessionStorage.getItem("Allergeni") ? (
            <TabPanel header="Allergeni">
              <ListaAllergeni prodottoid={this.state.prodottoid} stato={this.state.tipo} />
            </TabPanel>
          ) : (
            ""
          )}
          <TabPanel header="Produzione">
            <ListaProduzioni prodottoid={this.state.prodottoid} stato={this.state.tipo} />
          </TabPanel>
          {sessionStorage.getItem("Annate") ? (
            <TabPanel header="Annate">
              <ListaAnnata prodottoid={this.state.prodottoid} stato={this.state.tipo} />
            </TabPanel>
          ) : (
            ""
          )}
          <TabPanel header="Lotti">
            <ListaLotti prodottoid={this.state.prodottoid} stato={this.state.tipo} />
          </TabPanel>
          <TabPanel header="Certificazioni">
            <ListaCertificazioniProdotto prodottoid={this.state.prodottoid} stato={this.state.tipo} />
          </TabPanel>
        </TabView>

        <ConfirmDialog
          visible={this.state.visible3}
          onHide={() => this.setVisible3(false)}
          message="Hai valorizzato tutti i dati che andranno su Blockchain?"
          icon="pi pi-exclamation-triangle"
          acceptLabel="Conferma"
          rejectLabel="Annulla"
          accept={() => this.notarizza2()}
          reject={() => this.setVisible3(false)}
        />
      </div>
    );
  }
}

export default Prodotto;
